<template>
    <div>
        <v-container style="max-width: 1300px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 1rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" dark>
                    Usuarios
                    <!--  <v-tooltip bottom color="success">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="green" v-bind="attrs" v-on="on" dark @click="exportExcel"
                                style="margin: 1rem 0;height: 1.9rem;">
                                <v-icon color="white"
                                    style="font-size: 1.5rem;color: white !important;">mdi-download-box</v-icon>
                            </v-btn>
                        </template>
<span>Descargar</span>
</v-tooltip> -->
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1"
                style="margin-bottom: 2rem !important;padding: 2rem .6rem 0 .6rem;">
                <v-row>
                    <v-col cols="12" lg="3" md="4">
                        <v-text-field max-width="200" class="mx-3" v-model="searchNombre" label="Nombre"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="4">
                        <v-text-field max-width="200" class="mx-3" v-model="searchRol" label="Rol"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="4">
                        <v-text-field max-width="200" class="mx-3" v-model="searchArea" label="Área"
                            append-icon="mdi-magnify" outlined dense>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="4">
                        <v-btn color="primary" @click="dialogEdit = true" style="margin: 1rem !important;">
                            nuevo
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" style=" margin:0 auto;padding: 1.5rem;">
                <div>
                    <v-data-table :headers="filteredHeaders" :items="filteredData" :loading="isLoading" dense
                        loading-text="Cargando... Por favor espere" style="margin: 0 auto;">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top color="green" v-if="!item.estado">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark color="green" v-bind="attrs" v-on="on"
                                        @click="darAltaUsuario(item)">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-transfer-up
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Dar de alta</span>
                            </v-tooltip>
                            <v-tooltip top color="red" v-if="item.estado">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark color="red" v-bind="attrs" v-on="on"
                                        @click="darBajaUsuario(item)">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-transfer-down
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Dar de baja</span>
                            </v-tooltip>
                            <v-tooltip top color="teal" v-if="item.estado">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark @click="openEdit(item)" color="teal"
                                        v-bind="attrs" v-on="on">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-account-edit
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.estado`]="{ item }">
                            <span :class="item.estado ? 'activo' : 'desactivado'">
                                {{ item.estado ? 'Activo' : 'Desactivado' }}
                            </span>
                        </template>

                    </v-data-table>
                </div>
                <v-dialog v-model="dialogEdit" v-if="dialogEdit" persistent max-width="800px">
                    <v-card>
                        <v-card-title class="headline"> Usuario</v-card-title>
                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="usuarioForm.nombre" label="Nombres" required dense
                                            outlined></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="usuarioForm.usuario_id" :items="dataUsuariosHisar" label="Usuario" required dense item-text="nombre" item-value="idUsuario" outlined></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="4">
                                        <v-text-field v-model="usuarioForm.correo" label="Correo" required dense
                                            outlined></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-autocomplete v-model="usuarioForm.rol_id" label="Rol" :items="arrayRoles"
                                            required dense item-text="nombre" item-value="id" outlined>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-autocomplete v-model="usuarioForm.area_id" label="Área" :items="arrayAreas"
                                            required dense item-text="nombre" item-value="id" outlined>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="save" v-if="!statusEdit">Guardar</v-btn>
                            <v-btn color="primary" @click="edit" v-if="statusEdit">Editar</v-btn>
                            <v-btn color="secondary" text @click="closeEdit">Cancelar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <!--
                    <v-dialog v-model="dialogImport" v-if="dialogImport" max-width="700px">
                        <importPaciente @closeDialog="closeDialog" :date="date"></importPaciente>
                    </v-dialog> 
                -->
            </v-card>
            <!-- <v-dialog v-model="dialogHistograma" v-if="dialogHistograma" persistent width="800" class="fondo-griss">
                <v-card>
                    <Histograma @closeHistograma="closeHistograma"></Histograma>
                </v-card>
            </v-dialog> -->
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
        </v-container>
    </div>
</template>
<style scoped>
.activo {
    color: rgb(255, 255, 255);
    background: #74d467;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

.desactivado {
    color: rgb(255, 255, 255);
    background: #df4141;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

::v-deep .theme--dark.v-system-bar {
    color: hsl(0, 0%, 100%) !important;
}

.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
}

.custom-btn {
    width: 25px !important;
    height: 25px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}
</style>
<script>
import { faThumbTackSlash } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";

/* import importPaciente from "./import.vue";
import Histograma from "./histograma.vue"; */
export default {
    data() {
        return {
            valid: true,
            idUsuario: null,
            titleButton: 'Guardar',
            usuarioForm: {
                usuario_id:null,
                nombre: null,
                correo: null,
                rol_id: null,
                area_id: null
            },
            salasItems: [
                { label: "Clínicas", value: "0" },
                { label: "S1 CNSR", value: "1" },
                { label: "S2 CNSR", value: "2" },
                { label: "S3 CNSR", value: "3" },
                { label: "S4 CNSR", value: "4" },
                { label: "S5 DP", value: "5" }
            ],
            searchSala: [],
            statusEdit: false,
            dialogHistograma: false,
            date: new Date().toISOString().slice(0, 7),
            modal: false,
            searchNombre: null,
            searchRol: null,
            searchArea: null,
            dialogImport: false,
            dialogLoader: false,
            ver: false,
            searchDocumento: "",
            dataPaciente: [],
            dataEnvio: {
                fecha: null,
            },
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "Nombre", value: "nombre" },
                { text: "Correo", value: "correo", align: "center" },
                { text: "Rol", value: "rol", align: "center" },
                { text: "Área", value: "area", align: "center" },
                { text: "Estado", value: "estado", align: "center" },
                { text: "Acciones", value: "actions", align: "right" }
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            menu: false,
            idItem: null,
            selectedColumns: [
                'FECHA_RESULTADO', 'NUM_DOC', 'AUTOGENERADO', 'PACIENTE', 'SALA', 'ALBUMINA', 'CALCIO_TOTAL', 'CALCIO_POST', 'CALCIO_PRE', 'CALCIO_IONIZADO', 'CLORURO', 'COLESTEROL', 'CREATININA',
                'CREATININA_POST', 'CREATININA_PRE', 'FERRITINA', 'GLUCOSA', 'FIERRO', 'COLESTEROL_HDL', 'COLESTEROL_LDL', 'PARATOHORMONA', 'FOSFATASA_ALCALINA', 'FOSFORO', 'FOSFORO_POST', 'FOSFORO_PRE', 'POTASIO', 'SODIO', 'TRANSAMINASA_GLUTAMICO_PIRUVIC', 'TRANSAMINASA_GLUTAMICO_OXALACE', 'TRANSFERRINA', 'TRIGLICERIDOS', 'UREA', 'ACIDO_URICO', 'GLOBULOS_BLANCOS', 'GLOBULOS_ROJOS', 'HEMATOCRITO', 'HEMOGLOBINA', 'PROTEINA_C_REACTIVA', 'ANTIGENO_HEPATIT', 'ANTICUERPO_HEPATITIS_CORE', 'ANTICUERPO_HEPATITIS_C', 'UREA_PRE', 'UREA_POST', 'HCO3', 'POR_SATURACION', 'ACIDO_FOLICO', 'VITAMINA_B12', 'SEROLOGIA', 'ANTIGENO_SUPERFICIE_HEPAT', 'BETA_2', 'VITAMINA_D'
            ],
            itemMes: null,
            itemPeriodo: null,
            dataArray: [],
            arrayAreas: [],
            arrayRoles: [],
            dataUsuariosHisar:[]
        };
    },
    methods: {
        loadUsuarioHisar() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/usuarioIndex/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataUsuariosHisar = res.data;
                            this.dataUsuariosHisar.forEach((item) => {
                                // Calcula el nombre completo y guárdalo en una nueva propiedad 'nombreCompleto'
                                item.idUsuario = parseInt(item.url.split("/")[4], 10);
                            });
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        darAltaUsuario(item) {
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de dar de alta al usuario?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                    this.dialogLoader = true;
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .patch(RUTA_API + "/auditorio_personal/" + item.id + "/", {
                                    estado: true
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    Swal.fire({
                                        title: "¡Exito!",
                                        icon: "success",
                                        draggable: true
                                    });
                                    this.dialogLoader = false;
                                    this.dataInit();

                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });

                }
            });
        },
        darBajaUsuario(item) {
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de dar de baja al usuario?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                    this.dialogLoader = true;
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .patch(RUTA_API + "/auditorio_personal/" + item.id + "/", {
                                    estado: false
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    Swal.fire({
                                        title: "¡Exito!",
                                        icon: "success",
                                        draggable: true
                                    });
                                    this.dialogLoader = false;
                                    this.dataInit();

                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });

                }
            });
        },
        clearForm() {
            this.usuarioForm = {
                nombre: null,
                correo: null,
                rol_id: null,
                area_id: null,
                usuario_id:null
            }
        },
        loadRoles() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/auditorio_roles/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayRoles = res.data;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadAreas() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/auditorio-areas/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayAreas = res.data;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        openEdit(item) {
            this.statusEdit=true;
            this.idUsuario = item.id;
            this.dialogEdit = true;
            this.usuarioForm.nombre = item.nombre;
            this.usuarioForm.correo = item.correo;
            this.usuarioForm.rol_id = item.rol_id;
            this.usuarioForm.area_id = item.area_id;
            this.usuarioForm.usuario_id=parseInt(item.usuario_id, 10);
        },
        closeEdit() {
            this.statusEdit=false;
            this.dialogEdit = false;
            this.clearForm();
        },
        save() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/auditorio_personal/", {
                            area_id:this.usuarioForm.area_id,
                            correo:this.usuarioForm.correo,
                            nombre:this.usuarioForm.nombre,
                            rol_id:this.usuarioForm.rol_id,
                            usuario_id:this.usuarioForm.usuario_id
                        }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "El usuario se registró con exito.",
                                icon: "success",
                                draggable: true
                            });
                            this.dialogEdit = false;
                            this.dataInit();
                            this.dialogLoader = false;
                            this.clearForm();
                            this.statusEdit=false;

                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        edit() {
            this.dialogLoader = true;
            this.statusEdit = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .put(RUTA_API + "/auditorio_personal/" + this.idUsuario + "/", this.usuarioForm, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "El usuario se editó con exito.",
                                icon: "success",
                                draggable: true
                            });
                            this.clearForm();
                            this.dialogEdit = false;
                            this.dataInit();
                            this.dialogLoader = false;
                            this.statusEdit=false;

                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        closeHistograma() {
            this.dialogHistograma = false;
        },
        saveDate() {
            // Ejecuta la lógica adicional
            this.loadPeriodo();
            // Luego ejecuta la función de guardado del diálogo
            this.$refs.dialog.save(this.date);
        },
        loadPeriodo() {
            let [year, month] = this.date.split('-');
            this.itemMes = month;
            this.itemPeriodo = year;
            this.dataInit();
        },
        closeDialog() {
            this.dialogImport = false;
            this.dataInit();
        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/auditorio_personal/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataPaciente = res.data;

                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        formatearFecha(fecha) {
            // Dividir la fecha en partes: año, mes y día
            const partes = fecha.split("-");
            // Crear una nueva fecha con el formato "mm-dd-yyyy"
            const nuevaFecha = new Date(`${partes[1]}/${partes[2]}/${partes[0]}`);
            // Obtener el mes, día y año de la nueva fecha
            const mes = nuevaFecha.getMonth() + 1;
            const dia = nuevaFecha.getDate();
            const año = nuevaFecha.getFullYear();
            // Formatear la fecha en el formato deseado
            return `${mes.toString().padStart(2, "0")}-${dia
                .toString()
                .padStart(2, "0")}-${año}`;
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers;
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        computedDateFormatted1() {
            return this.formatDate(this.date1);
        },
        icon() {
            if (this.likesAllFruit) return 'mdi-close-box'
            if (this.likesSomeFruit) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        likesAllFruit() {
            return this.headers.length === this.selectedColumns.length
        },
        likesSomeFruit() {
            return this.headers.length > 0 && !this.likesAllFruit
        },
        dataCasOptions() {
            // Formatear los elementos del objeto según lo requerido por v-select
            return this.dataCas.map((item) => ({
                text: item.descripCas,
                value: item.url,
            }));
        },
        itemClass() {
            return (item) => {
                if (item.cupos_disponible === 0) {
                    return "";
                } else {
                    return "bg-primary-table primary--text";
                }
            };
        },
        filteredData() {
            if (!this.searchNombre && !this.searchRol && !this.searchArea) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchNombre) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.nombre;
                    return nombreCompleto.toLowerCase().includes(this.searchNombre.toLowerCase());
                });
            }
            if (this.searchRol) {
                filtered = filtered.filter((item) =>
                    item.rol
                        .toLowerCase()
                        .includes(this.searchRol.toLowerCase())
                );
            }
            if (this.searchArea) {
                filtered = filtered.filter((item) =>
                    item.area
                        .toLowerCase()
                        .includes(this.searchArea.toLowerCase())
                );
            }
            return filtered;
        },
    },
    created() {
        this.loadUsuarioHisar();
        this.loadAreas();
        this.loadRoles();
        this.dataInit();
    },
    components: {
        /*  importPaciente,
         Histograma */
    },
};
</script>